export default class Library
{
    constructor ()
    {
        if (Library.instance)
        {
            return;
        }

        Library.instance = this;

        this.resources = [];
        this.datas = [];
        this.shaders = [];
    }


    addLoadedAssets (loaded, arrAssets)
    {

                let keys = Object.keys(loaded);

                for (let i = 0; i < keys.length; i++)
                {
                    let key = keys[i];
                    let asset = arrAssets.find((a) => a.versionUrl === key);

                    asset.texture = loaded[key];

                    this.resources.push(asset);
                }



    }

    addShader (key, shader)
    {
        this.shaders.push ({key, shader});
    }
    setResources (resources)
    {
        console.log("Library  setResources", resources);
    }

    getResourceByKey (key)
    {
        return this.resources.find( (r) => r.key === key);
    }

    addData (key, data)
    {
        this.datas.push({key, data});
    }
    getData (key)
    {
        return this.datas.find( (r) => r.key === key);
    }

    getTexture (key)
    {
        let resource = this.getResourceByKey(key);

        if (!resource)
            return null;

        let texture = resource.texture;


        return texture
    }

    getTextureFromAtlas (key, frame)
    {
        let atlas = this.getResourceByKey(key);

        if (!atlas)
            return null;

        let texture = atlas.texture;

        //we check if the frame is in the first atlas (it might be more than 1 sheet)
        let hasFrame = texture._frameKeys.find( (f) => f === frame);

        if (hasFrame)
        {
            return texture.textures[frame]
        }

        for (let i = 0; i < texture.linkedSheets.length; i++)
        {
            let sheet = texture.linkedSheets[i];

            hasFrame = sheet._frameKeys.find( (f) => f === frame);

            if (hasFrame)
            {
                return sheet.textures[frame]
            }
        }

        //if we are here, we didn't find the texture
        return null;

    }

    getShaderByKey (key)
    {
        let shader = this.shaders.find( (r) => r.key === key);

        if (!shader)
            return null;

        return shader.shader;
    }
}


let l = new Library();
